import React, { FC } from 'react';
import { MenuProvider } from './context';
import { Menu as MenuBase } from './Menu';
import { IMenuProps } from './models';
import { MenuItem } from './_Item/MenuItem';
import { MenuSection } from './_Section/MenuSection';

interface INestedComponents {
  Item: typeof MenuItem;
  Section: typeof MenuSection;
}

export const Menu: FC<IMenuProps> & INestedComponents = ({ theme, children, ...props }) => (
  <MenuProvider theme={theme}>
    <MenuBase {...props}>{children}</MenuBase>
  </MenuProvider>
);

Menu.Item = MenuItem;
Menu.Section = MenuSection;
